/*
 * @Author: your name
 * @Date: 2022-02-21 17:36:04
 * @LastEditTime: 2022-03-01 15:09:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \fangGuanShiPinXiaoGuanJia\src\utils\common.js
 */
// UUID生成
export function webGenerateUuid(len) {
    len = len || 32;
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = chars.length;
    let uuid = '';
    for (let i = 0; i < len; i++) {
        uuid += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return uuid;
}

export const formatTime = date => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    return `${[year, month, day].map(formatNumber).join('-')}`
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : `0${n}`
}

let _debounceTimeout = null,
    _throttleRunning = false

/**
 * 防抖
 * @param {Function} 执行函数
 * @param {Number} delay 延时ms   
 */
export const debounce = (fn, delay = 500) => {
    clearTimeout(_debounceTimeout);
    _debounceTimeout = setTimeout(() => {
        fn();
    }, delay);
}
/**
 * 节流
 * @param {Function} 执行函数
 * @param {Number} delay 延时ms  
 */
export const throttle = (fn, delay = 500) => {
    if (_throttleRunning) {
        return;
    }
    _throttleRunning = true;
    fn();
    setTimeout(() => {
        _throttleRunning = false;
    }, delay);
}
/**
 * toast
 */

//通用方法
export function isEmpty(v) {
    if (
        typeof v == "undefined" ||
        v == null ||
        v == "" ||
        isNaN(v) ||
        v === false
    ) {
        //console.log("isEmpty 为true")
        return true;
    } else {
        //console.log("isEmpty 为false")
        return false;
    }
}

export function clearObjEmptyProperty(obj) {
    for (let key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      if (obj[key] === null || obj[key] === undefined || isNaN(obj[key])) {
        obj[key] = "";
      }
    }
    return obj;
  }
  


/////////////////  对象   ////////////////////



/**
 * 对象 属性 为 null 的 转成字符串 "无"
 */

export function transObjPropertyNullToString(obj, str) {
    //str = "无"
    for (let key in obj) {
        if (isEmpty(obj[key])) {
            obj[key] = str;
        }
    }
    return obj;
}


/**
 * 对象 属性 为  "无"  的 转成字符串 null
 */

export function transObjPropertyStingToNull(obj, str) {
    //str = "无"
    for (let key in obj) {
        if (obj[key] === str) {
            obj[key] = null;
        }
    }
    return obj;
}

/**
 * 清空对象
 */


export function clearObjProperty(obj) {
    for (let key in obj) {
        obj[key] = "";
    }
    return obj;
}

/****
 * 
 */

export function removeEmptyProps(obj) {
    for (let prop in obj) {
        if (obj[prop] === null || obj[prop] === undefined || obj[prop] === '') {
            delete obj[prop];
          }
    //   if (!obj[prop]) {  //0 会被 删掉
    //     delete obj[prop];
    //   }
    }
    return obj
  }

/**
 * 对象深拷贝
 */
export const deepClone = (data) => {
    let type = getObjType(data);
    let obj;
    if (type === "array") {
        obj = [];
    } else if (type === "object") {
        obj = {};
    } else {
        // 不再具有下一层次
        return data;
    }
    if (type === "array") {
        for (let i = 0, len = data.length; i < len; i++) {
            obj.push(deepClone(data[i]));
        }
    } else if (type === "object") {
        for (let key in data) {
            obj[key] = deepClone(data[key]);
        }
    }
    return obj;
};


/**
 * 对象是否为空
 */
export function isEnptyObj(obj) {
    if (Object.keys(obj).length === 0) {
        return true; //如果为空，返回false
    }
    return false; //如果不为空，返回true
}


/**
 * 判断对象是否相等
 */
export const diff = (obj1, obj2) => {
    delete obj1.close;
    let o1 = obj1 instanceof Object;
    let o2 = obj2 instanceof Object;
    if (!o1 || !o2) {
        /*  判断不是对象  */
        return obj1 === obj2;
    }

    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
        //Object.keys() 返回一个由对象的自身可枚举属性(key值)组成的数组,例如：数组返回下表：let arr = ["a", "b", "c"];console.log(Object.keys(arr))->0,1,2;
    }

    for (let attr in obj1) {
        let t1 = obj1[attr] instanceof Object;
        let t2 = obj2[attr] instanceof Object;
        if (t1 && t2) {
            return diff(obj1[attr], obj2[attr]);
        } else if (obj1[attr] !== obj2[attr]) {
            return false;
        }
    }
    return true;
};



/////////////////  数组   ////////////////////


/**
 *  获取数组 中 的最大值
 */
export function findMaxInArr(arr) {
    let num = Math.max.apply(null, arr);
    return num;
}

/**
 *  获取数组 中 最大的数是几位数
 */
export function getMaxDigitsInArr(arr) {
    let max = findMaxInArr(arr);
    let digi = getDigits(max);
    return digi

}

/***
 * 两个数组是否包含所有
 * ***/

export function arrIncludes(arr1, arr2) {
    return arr2.every((val) => arr1.includes(val));
}

/***
 * 抽中 数组中
 * 
 * ***/

export function newArrById(arr) {
    let newArr = [];
    for (let i = 0; i < arr.length; i++) {
        let id = arr[i].id;
        newArr.push(id);
    }

    return newArr

}


/**
 *  数组里  重复对象 去重
 */
export function removeDuplicate(arr) {
	const uniqueArr = [];
	for (let i = 0; i < arr.length; i++) {
	  if (uniqueArr.indexOf(arr[i]) === -1) {
		uniqueArr.push(arr[i]);
	  }
	}
	return uniqueArr;
}

/**
 *  拷贝数组
 */
export function cloenArr(arr) {
    let newArr = JSON.parse(JSON.stringify(arr));
    return newArr
}

export function includes(arr1, arr2) {
    return arr2.every((val) => arr1.includes(val));
}

export function getParentId(list, iid) {
    for (let o of list || []) {
        if (o.id == iid) return o;
        const o_ = this.getParentId(o.children, iid);
        if (o_) return o_;
    }
}
export function getArrDifference(arr1, arr2) {
    return arr1.concat(arr2).filter(function (v, i, arr) {
        return arr.indexOf(v) === arr.lastIndexOf(v);
    });
}


/**
 *  数组里  重复对象 去重
 */
export function filterDouble(v) {
    let tagArry = v;
    let hash = {};
    let dataList = [];
    dataList = tagArry.reduce((preVal, curVal) => {
        hash[curVal.id] ? "" : (hash[curVal.id] = true && preVal.push(curVal));
        return preVal;
    }, []);
    return dataList;
}

/**
 *  数组去重
 */

export function deArrDupe(array) {
    return Array.from(new Set(array));
}


export function filterCode(v) {
    let tagArry = v;
    let hash = {};
    let dataList = [];
    dataList = tagArry.reduce((preVal, curVal) => {
        hash[curVal.code] ? "" : (hash[curVal.code] = true && preVal.push(curVal));
        return preVal;
    }, []);
    return dataList;
}

//删除 数组种 特定某元素
export function arryRemoveElement(val, arr) {
    let index = arr.indexOf(val);
    if (index > -1) {
        arr.splice(index, 1);
    }

    // return index;
    return arr;
}




//计算数组总数
export function calculateTotal(array) {
    let numArray = array;
    let sum = 0;
    for (let i = 0; i < numArray.length; i++) {
        sum += numArray[i];
    }

    return sum;
}

//数组去空
export function arrDeletNull(array) {
    let list = [];
    array.map((value) => {
        if (!!value) {
            list.push(value);
        }
    });

    return list;
}

//判断数组是否 有某个元素
export function arrIsHave(array, item) {
    if (array.indexOf(item) > -1) {
        return true;
    } else {
        return false;
    }
}

//根据 数组 脚标，截取数组
export function arrCutByIdx(arr, idx) {
    let newArr = [];
    for (let i = 0; i < idx; i++) {
        let obj = {};
        obj = arr[i];
        newArr.push(obj);
    }
    return newArr;
}

//数组排序  排时间 时 "00:00"-"24:00"
export function sortTime(list) {
    let tlist = list
    for (var i = 0; i < tlist.length - 1; i++) {

        for (var j = 0; j < tlist.length - i - 1; j++) {

            if (tlist[j].hourStart > tlist[j + 1].hourStart) {
                var tem = tlist[j];
                tlist[j] = tlist[j + 1];
                tlist[j + 1] = tem;
            }
        }
    }

    // console.log(1111111111,tlist)
    return tlist
}


//数组 递归 设置

export function setArrChildrenNameType(arr, str) {
    //   let newArr = [];
    let typeTxt = str;
    arr.forEach((item) => {
        item.name = item.organizationName;
        item.type = str;
        if (item.children) {
            setArrChildrenNameType(item.children, typeTxt)
        }
        return item;
    })

    return arr
}

///////////////////////////字符串处理
export function getLastString(inputString) {
    // 使用 split 方法按斜杠分割字符串，取最后一个元素
    const parts = inputString.split('/');
    return parts[parts.length - 1];
}


//去掉字符串 头尾的空格
export function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
}

//将 字符串里的 "/" 去除掉
export function removeBackslash(str) {
    return str.replace(/\\/g, '');
  }



//根据idx的定位 返回 str 从 0 到idx 的字符串
export function strCutByIdx(str, idx) {
    let newStr = str.substring(0, idx);
    return newStr;
}

//根据idx的定位 返回 str 从 idx0  到idx1 的字符串
export function strSelectedByIdx(str, idx0, idx1) {
    let newStr = str.substring(idx0, idx1);
    return newStr;
}

export function getStrLength(val) {
    let len = 0;
    for (let i = 0; i < val.length; i++) {
        let a = val.charAt(i);
        if (a.match(/[^\x00-\xff]/ig) != null) {
            len += 2;
        } else {
            len += 1;
        }
    }
    return len;
}

//除了数字和字母意外 去除特殊字符
export function removeSpecialChars(str) {
    return str.replace(/[^a-zA-Z0-9\u4e00-\u9fa5]/g, '');
  }



//去除回车
export function clearBr(str) {
    str = str.replace(/\r\n|\n|\r/g, "");
    return str;
}


//去除富文本
export function clearTag(str) {
    let fn_result = str;
    fn_result = fn_result.replace(/(↵)/g, "");
    // fn_result = fn_result.replace(/\s*|\t|\r|\n/g, "");// 去除tab、空格、空行(会去掉图片和字体颜色样式)
    fn_result = fn_result.replace(/(&nbsp;)/g, "");
    fn_result = fn_result.replace("<html><head><title></title></head><body>", "");
    fn_result = fn_result.replace("</body></html>", "");
    console.log(fn_result.length)
    return fn_result;

}

//判断是否是车牌号

export function isLicensePlate(str) {
    const pattern = /^[\u4e00-\u9fa5]{1}[A-Z]{1}[A-Z_0-9]{5}$/;
    return pattern.test(str);
}

////////////////////////// 数字处理 ///////////

//截取小数点 后几两位
export function strCutTwoDigits(str, idx) {
    let aNew = "";
    aNew = str.toFixed(idx);
    return aNew
}

/***
 * 
 * 获取数字是几位数
 */

export function getDigits(val) {
    let num = parseInt(val);
    let resNum = 0;
    while (num >= 1) {
        num = num / 10;
        resNum++;
    }
    return resNum
}

/***
 * 
 * 保留小数点 后 index 位
 */

export function getnum(str, index = 2) {
    const num = Number(str),
        n = Number(index);
    return num.toFixed(n)
}


/////////////////////////// 随机数 /////////////

/**
 * 随机数
 */

export function getRandomNum() {
    let num = Math.random()
        .toString()
        .replace(/\d+\.(\d*)/, "$1");
    return num;
}

/////////////////////////// 屏幕设置 /////////////

//屏幕设置
export function getScreenSet() {
    let screenRate = null;
    uni.getSystemInfo({
        success: function (res) {
            screenRate = res.windowHeight / res.windowWidth;
        },
    });

    let sw = 750;
    let screenTotalW = 750 + "rpx";
    let screenTotalH = sw * screenRate + "rpx";

    let reBackObj = {};
    reBackObj.screenTotalW = screenTotalW;
    reBackObj.screenTotalH = screenTotalH;

    return reBackObj;
}

/////////////////////////// 货币相关  /////////////////////////

//转大写
export function toBigWord(n) {
    let fraction = ['角', '分'];
    let digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];

    let unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    let head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    let s = '';
    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }

    s = s || '整';
    n = Math.floor(n);
    for (i = 0; i < unit[0].length && n > 0; i++) {
        let p = '';
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');

}


/****
 * 转百分比
 */

export function formatPercentage(row, column, cellValue) {
    const v = math.multiply(Number.parseFloat(cellValue), 100);
    return v + '%';
}


/////////////////////////// 时间相关  //////////////////////////

export function extractDateTime(inputString) {
    // 正则表达式匹配年月日和时分秒
    const regex = /(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2}:\d{2})/;
    const match = inputString.match(regex);

    if (match) {
      return {
        date: match[1], // 年月日
        time: match[2], // 时分秒
      };
    } else {
      return null;
    }
  }


//获取当前时间
export function getTime(type) {
    let timeSting = "";

    let time = new Date();
    time.getYear(); //获取当前年份
    time.getFullYear(); //获取完整的年份(4位,1970-???)
    time.getMonth(); //获取当前月份(0-11,0代表1月)
    time.getDate(); //获取当前日(1-31)
    time.getDay(); //获取当前星期X(0-6,0代表星期天)
    time.getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
    time.getHours(); //获取当前小时数(0-23)
    time.getMinutes(); //获取当前分钟数(0-59)
    time.getSeconds(); //获取当前秒数(0-59)
    time.getMilliseconds(); //获取当前毫秒数(0-999)
    time.toLocaleDateString(); //获取当前日期
    // let mytime = time.toLocaleTimeString(); //获取当前时间
    time.toLocaleString(); //获取日期与时间

    let nowHours = time.getHours();
    let nowMinutes = time.getMinutes();

    let nowDay = time.getDate();
    if (nowDay < 10) nowDay = "0" + nowDay;

    let nowSeconds = time.getSeconds();

    let nowMonths = time.getMonth() + 1;
    if (nowMonths < 10) nowMonths = "0" + nowMonths;

    //console.log("time.getMonth",nowMonths);

    if (type == "day") {
        timeSting =
            // time.toLocaleDateString() +
            time.getFullYear() + "-" + nowMonths + "-" + nowDay;
    } else {
        timeSting =
            // time.toLocaleDateString() +
            time.getFullYear() + "-" + nowMonths + "-" + nowDay +
            " " +
            nowHours +
            ":" +
            nowMinutes +
            ":" +
            nowSeconds;
        //timeSting = time.toLocaleString();

    }



    return timeSting;
}



//获取当前时间
export function getNowTime(type) {

    let time = new Date();
    time.getYear(); //获取当前年份
    time.getFullYear(); //获取完整的年份(4位,1970-???)
    time.getMonth(); //获取当前月份(0-11,0代表1月)
    time.getDate(); //获取当前日(1-31)
    time.getDay(); //获取当前星期X(0-6,0代表星期天)
    time.getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
    time.getHours(); //获取当前小时数(0-23)
    time.getMinutes(); //获取当前分钟数(0-59)
    time.getSeconds(); //获取当前秒数(0-59)
    time.getMilliseconds(); //获取当前毫秒数(0-999)
    time.toLocaleDateString(); //获取当前日期
    let mytime = time.toLocaleTimeString(); //获取当前时间
    time.toLocaleString(); //获取日期与时间

    let nowHours = time.getHours();
    let nowMinutes = time.getMinutes();
    let nowSeconds = time.getSeconds();
    let beforeOneMonths = (time.getMonth()).toString();
    if (beforeOneMonths.length <= 1) beforeOneMonths = '0' + beforeOneMonths;
    let nowMonths = (time.getMonth() + 1).toString();
    if (nowMonths.length <= 1) nowMonths = '0' + nowMonths;
    let nowDays = time.getDate().toString()
    if (nowDays.length <= 1) nowDays = '0' + nowDays;
    //console.log("time.getMonth",nowMonths);

    let timeSting0 = time.getFullYear() + "-" + nowMonths + "-" + nowDays;
    let timeSting1 =
        // time.toLocaleDateString() +
        time.getFullYear() + "-" + nowMonths + "-" + nowDays +
        " " +
        nowHours +
        ":" +
        nowMinutes +
        ":" +
        nowSeconds;
    //timeSting = time.toLocaleString();
    let setYear = time.getFullYear()
    if (type == "year") {
        return time.getFullYear()
    } else if(type == "beforeMonthsFull"){
        return time.getFullYear() + "-" + beforeOneMonths
    }else if(type == "beforeOneMonths"){
        return beforeOneMonths
    }else if(type == "beforeMonthsFirstDay"){

        let monthsFirstDay = time.getFullYear() + "-" + beforeOneMonths + "-" + "01"
        return monthsFirstDay
    } else if(type == "beforeMonthsLastDay"){
        let dateObj = new Date(setYear, beforeOneMonths, 0);
        let theMonthDay = dateObj.getDate();
        let monthsLastDay = time.getFullYear() + "-" + beforeOneMonths + "-" + theMonthDay
        return monthsLastDay

    } else if (type == "months") {
        return time.getFullYear() + "-" + nowMonths
    } else if (type == "monthsLastDay") {
        
        let setMonths = nowMonths;
        let dateObj = new Date(setYear, setMonths, 0);
        let theMonthDay = dateObj.getDate();
        let monthsLastDay = time.getFullYear() + "-" + nowMonths + "-" + theMonthDay
        return monthsLastDay
    } else if (type == "date" || type == "day") {
        return timeSting0
    } else if(type == "7dayAgo"){
       
        let seventhDayAgo = new Date();
        seventhDayAgo.setDate(time.getDate() - 7);

        let year = seventhDayAgo.getFullYear();
        // let month = seventhDayAgo.getMonth() + 1; // 月份从0开始，所以要加1
        let nowMonths = (seventhDayAgo.getMonth() + 1).toString();
        if (nowMonths.length <= 1) nowMonths = '0' + nowMonths;

        let day = seventhDayAgo.getDate();
        let formattedDate = year + '-' + nowMonths + '-' + day;
        return formattedDate
    }else if (type == "min") {
        return nowHours + ":" + nowMinutes + ":" + nowSeconds;
    } else if (type == "all") {
        return timeSting1;
    } else {
        return timeSting1;
    }

}

//昨天
export function getYesterday(num, str) {
    var today = new Date();
    var nowTime = today.getTime();
    var ms = 24 * 3600 * 1000 * num;
    today.setTime(parseInt(nowTime + ms));
    var oYear = today.getFullYear();
    var oMoth = (today.getMonth() + 1).toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    var oDay = today.getDate().toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    return oYear + str + oMoth + str + oDay;
}

//通过js来获取前天、昨天、今天、明天、后天、大后天的日期
export function GetDateStr(AddDayCount) {
    let dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount);//获取AddDayCount天后的日期 
    let y = dd.getFullYear();
    let m = dd.getMonth() + 1;//获取当前月份的日期 
    let oMoth = m.toString();
    if (oMoth.length <= 1) oMoth = '0' + oMoth;
    let d = dd.getDate();
    let oDay = d.toString();
    if (oDay.length <= 1) oDay = '0' + oDay;
    return y + "-" + oMoth + "-" + oDay;

    //例子
    //GetDateStr(-2); //前天
    //GetDateStr(-1); //昨天
    //GetDateStr(0);  //今天
    //GetDateStr(1);  //明天
    //GetDateStr(2);  //后天
    //GetDateStr(3);  //大后天
}



export function resSetTime(time, str) {
    // let arr = time.split(" ")
    // let t1 = arr[0] + " " + str; 
    let t0 = ""
    let t1 = "";
    if (time) {
        t0 = time.slice(0, 10);
        t1 = t0 + " " + str;
    }

    return t1
}

//日期转化为时间戳
export function toTimeStamp(time) {
    let date = new Date(time);
    let stampTime = Date.parse(date);
    return stampTime;
}

export function stampTransToMonths(timeStr){
    if(timeStr){
         let date = new Date(timeStr);
         let year = date.getFullYear();
         let month = (date.getMonth() + 1).toString().padStart(2, '0');
         let formattedDate = `${year}-${month}`;
         return formattedDate;
    }
 }


 export function stampTransToTime(timeStr){
    // if(timeStr){
    //      let date = new Date(timeStr);
    //      const year = date.getFullYear();
    //      const month = (date.getMonth() + 1).toString().padStart(2, '0');
    //      const day = date.getDate().toString().padStart(2, '0');
    //      const hour = date.getHours().toString().padStart(2, '0');
    //      const minute = date.getMinutes().toString().padStart(2, '0');
    //      const second = date.getSeconds().toString().padStart(2, '0');
    //      const formattedDate = `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    //      return formattedDate;
    // }
    
    const dateObj = new Date(timeStr);
    const year = dateObj.getFullYear();
    const month = ('0' + (dateObj.getMonth() + 1)).slice(-2); // 月份从0开始，所以要加1，并且前面补零
    const day = ('0' + dateObj.getDate()).slice(-2); // 前面补零
    const hours = ('0' + dateObj.getHours()).slice(-2); // 前面补零
    const minutes = ('0' + dateObj.getMinutes()).slice(-2); // 前面补零
    const seconds = ('0' + dateObj.getSeconds()).slice(-2); // 前面补零
  
    let formattedDate = `${year}-${month}-${day}`;
    if (hours || minutes || seconds) {
      formattedDate += ` ${hours}:${minutes}:${seconds}`;
    }
  
    return formattedDate;

 }

 export function returnTime24() {
    const now = new Date(); // 获取当前时间
    const previous = new Date(now.getTime() - 24 * 60 * 60 * 1000); // 获取之前24小时的时间
  
    const format = (date) => {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
  
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
  
    const nowFormatted = format(now);
    const previousFormatted = format(previous);
  
    return [previousFormatted,nowFormatted];
  }

 

//将时间 时，分，秒，切割为数组   时间格式为 2021/11/6 19:38:0
export function cutTimeByHMS(str) {
    // console.log("cutTimeByHMS", str);
    let timeArr = str.split(" ")[1];
    let timeCut = timeArr.split(":");
    let timeObj = {};
    timeObj.h = timeCut[0];
    timeObj.m = timeCut[1];
    timeObj.s = timeCut[2];
    // console.log("cutTimeByHMS timeCut", timeCut);
    return timeObj;
}

//输出 从给出的日期到现在的日期 还剩多少时间 输出为字符串
export function layOutLeftTime(str, nowTime) {
    //console.log("layOutLeftTime nowTime",nowTime);
    let d1 = new Date(nowTime.replace(/\-/g, "/"));
    // console.log("layOutLeftTime d1",d1);
    //let  d1= nowTime;
    let d2 = new Date(str.replace(/\-/g, "/"));
    //两个对象直接相减,就是相差的毫秒数
    let d = d2 - d1;
    //单位换算为秒，向下取整，去除小数部分
    //d=Math.floor( d/1000 );
    //计算相差的天数，把相差的值换算天
    //除以一天的秒数
    // let  day=Math.floor( d/(246060) );
    // //去除两者相差的值中所有的天数,让相差的值和一天的秒数取余
    // //得到的就是去除天数后的秒数部分
    // let  hour=d%(246060);
    // //再转为小时
    // hour=Math.floor( hour/(6060) );
    // //计算相差的分钟，去除相差的小时，让相差的值和每小时的秒数取余，得到的就是去除小时后的秒数部分，
    // let  minute=d%(6060);
    // //最后需要转为分钟
    // minute=Math.floor( minute/60 );
    // //计算相差的秒钟，去除相差的分钟
    // let  second=d%60;
    //console.log(day,hour,minute,second);

    let day = Math.floor(d / 1000 / 60 / 60 / 24);
    let hour = Math.floor(d / 1000 / 60 / 60 % 24);
    let minute = Math.floor(d / 1000 / 60 % 60);
    let second = Math.floor(d / 1000 % 60);


    let resObj = {};
    resObj.type = 2;
    resObj.day = day;
    resObj.hours = hour;
    resObj.minutes = minute;
    resObj.seconds = second;
    return resObj
}

//输出 从给出的日期到现在的日期 还剩多少时间 输出为对象
export function layOutLeftTimeObj(str, nowTime) {
    let timeStamp = toTimeStamp(str.replace(/\-/g, "/"));
    //console.log("timeStamp", timeStamp);

    //let nowTime = getNowTime();
    // console.log("layOutLeftTimeObj >>> nowTime", nowTime);
    let nowTimeStamp = toTimeStamp(nowTime.replace(/\-/g, "/"));
    //console.log("nowTimeStamp", nowTimeStamp);

    // //let nTime = nowTime - timeStr;
    let nTime = timeStamp - nowTimeStamp;

    let dayLength = Math.floor(nTime / 86400000);
    //console.log("layOutLeftTimeObj >>> dayLength", dayLength);

    // let leftDay = "";
    let resTimeObj = {};
    resTimeObj.type = ""; // 1 : 为天 ; 2: 为 时
    resTimeObj.day = "";
    resTimeObj.hours = "";
    resTimeObj.minutes = "";
    resTimeObj.seconds = "";

    if (dayLength > 0) {
        resTimeObj.type = 1;
        resTimeObj.day = dayLength;
        //console.log("layOutLeftTimeObj 剩余天数>>> 天", resTimeObj);
    } else {
        // console.log("str time",str);
        resTimeObj = layOutLeftTime(str, nowTime)
        // resTimeObj.type = 2;
        // resTimeObj.day = "";
        // resTimeObj.hours = cutTimeByHMS(str).h;
        // resTimeObj.minutes = cutTimeByHMS(str).m;
        // resTimeObj.seconds = cutTimeByHMS(str).s;
        //console.log("layOutLeftTimeObj 剩余天数>>> 时", resTimeObj);
    }

    return resTimeObj;
}




export function timeIncremental(d, num) {
    function checkTime(i) {
        if (i < 10) {
            i = "0" + i;
        }
        return i;
    }
    d = `2022-01-22 ${d}:00`;
    num = 60 * (60 * num);
    var d = new Date(
        d.substring(0, 4),
        d.substring(5, 7) - 1,
        d.substring(8, 10),
        d.substring(11, 13),
        d.substring(14, 16),
        d.substring(17, 19)
    );
    d.setTime(d.getTime() + num * 1000);
    return `${checkTime(d.getHours())}:${checkTime(d.getMinutes())}`;

}


/////////////////////下载文件  ////////////////

export function downLoadFile(res, fileName) {
    let blob = new Blob([res], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
    }); //application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    let downloadElement = document.createElement("a");
    let href = window.URL.createObjectURL(blob); //创建下载的链接
    downloadElement.href = href;
    downloadElement.download = fileName; //下载后文件名
    document.body.appendChild(downloadElement);
    downloadElement.click(); //点击下载
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象


    //   let blob = new Blob([res], {
    //     type: "application/pdf;chartset=UTF-8",
    //   });

    //   let url = window.URL.createObjectURL(blob);
    //   let link = document.createElement("a");
    //   link.style.display = "none";
    //   link.href = url;
    //   link.setAttribute("download", "xiaoJie.pdf");
    //   document.body.appendChild(link);
    //   link.click();

}




///////////////////// 图片相关  ///////////////


//图片 相关
//下载实体图片 到本地 仅用于 uniapp
export function downLoadImgByEntity(url) {
    let demoUrl = url

    uni.downloadFile({
        url: demoUrl, //仅为示例，并非真实的资源
        success: (res) => {
            if (res.statusCode === 200) {
                console.log("下载成功 res", res);
                uni.saveImageToPhotosAlbum({
                    //保存图片到系统相册。
                    filePath: res.tempFilePath, //图片文件路径
                    success: function () {
                        uni.showToast({
                            title: "图片保存成功",
                            icon: "none",
                        });
                    },
                    fail: function (e) {
                        console.log(e);
                        uni.showToast({
                            title: "图片保存失败",
                            icon: "none",
                        });
                    },
                });
            }
        },
    });

}

////下载base64图片 到本地 仅用于 uniapp
export function downLoadImgBase64(url) {
    let imgUrl = url;
    let base64 = imgUrl.replace(/^data:image\/\w+;base64,/, ""); //去掉data:image/png;base64,
    let filePath = wx.env.USER_DATA_PATH + "/hym_pay_qrcode.png";

    uni.getFileSystemManager().writeFile({
        filePath: filePath, //创建一个临时文件名
        data: base64, //写入的文本或二进制数据
        encoding: "base64", //写入当前文件的字符编码
        success: (res) => {
            uni.saveImageToPhotosAlbum({
                filePath: filePath,
                success: function (res2) {
                    // 	title: '保存成功',
                    console.log("保存成功");
                },
                fail: function (err) {
                    console.log(err.errMsg);
                },
            });
        },
        fail: (err) => {
            //console.log(err)
        },
    });

}

//计算经纬度

////经纬度转世界坐标
export function lonlat2World (lon,lat,h = 0){
	var r = 6378000+h;
	var lonArc = lon / 180 * Math.PI;
	var latArc = lat / 180 * Math.PI;
	var y = r * Math.sin(latArc);
	var curR = r * Math.cos(latArc);
	var x = -curR * Math.cos(lonArc);
	var z = curR * Math.sin(lonArc);
	return [x, y, z];
}
//计算向量长度
export function getVectorLength (v) {
	return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]);
}
//向量标准化
export function normalizeVector (v) {
	var length = getVectorLength(v) || 1;
	var m = 1.0 / length;
	return [v[0] * m, v[1] * m, v[2] * m];
}
//向量点乘
export function dotVectors (v1,v2) {
	return v1[0] * v2[0] + v1[1] * v2[1] + v1[2] * v2[2];
}
//根据单位向量得到四元数
export function setFromUnitVectors ( vFrom, vTo ) {
	var EPS = 0.000001;
	var result = [];
	var r = dotVectors(vFrom,vTo) + 1;
	if ( r < EPS ) {
		r = 0;
		if ( Math.abs( vFrom[0] ) > Math.abs( vFrom[2] ) ) {
			result[0] = - vFrom[1];
			result[1] = vFrom[0];
			result[2] = 0;
			result[3] = r;
		} else {
			result[0] = 0;
			result[1] = - vFrom[2];
			result[2] = vFrom[1];
			result[3] = r;
		}
	} 
	else {
		result[0] = vFrom[1] * vTo[2] - vFrom[2] * vTo[1];
		result[1] = vFrom[2] * vTo[0] - vFrom[0] * vTo[2];
		result[2] = vFrom[0] * vTo[1] - vFrom[1] * vTo[0];
		result[3] = r;
	}
	return normalizeQuaternion(result);
}
//归一化四元数
export function normalizeQuaternion (quaternion){
	var result = [];
	var l = Math.sqrt( quaternion[0] *quaternion[0] + quaternion[1] * quaternion[1] + quaternion[2] * quaternion[2] + quaternion[3] * quaternion[3]);
	if ( l === 0 ) {
		result[0] = 0;
		result[1] = 0;
		result[2] = 0;
		result[3] = 1;
	} else {
		l = 1 / l;
		result[0] = quaternion[0] * l;
		result[1] = quaternion[1] * l;
		result[2] = quaternion[2] * l;
		result[3] = quaternion[3] * l;
	}
	return result;
}
//根据坐标轴与角度得到四元数
export function setFromAxisAngle ( axis, angle ) {
	const result = [];
	const halfAngle = angle / 2;
	const s = Math.sin( halfAngle );
	result[0] = axis[0] * s;
	result[1] = axis[1] * s;
	result[2] = axis[2] * s;
	result[3] = Math.cos( halfAngle );
	return result;
}
//根据世界坐标与角度计算四元数
export function getWorldQuaternion (position,azimuth){
	if (azimuth===undefined) {
		azimuth = 0;
	}
	var oldDir = [0,1,0]; //当前up方向
	var targetDir = normalizeVector(position);
	var quat = setFromUnitVectors(oldDir, targetDir); //计算从当前up到目标up需要变换的四元数
	var quat2 = setFromAxisAngle( targetDir, azimuth/180*Math.PI );
	var result = multiplyQuaternions(quat2,quat);
	return result;
}
//四元数相乘
export function multiplyQuaternions ( a, b ) {
	var result = [];
	var qax = a[0], qay = a[1], qaz = a[2], qaw = a[3];
	var qbx = b[0], qby = b[1], qbz = b[2], qbw = b[3];
	result[0] = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
	result[1] = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
	result[2] = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
	result[3] = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
	return result;
}
//根据位置 旋转 缩放得到4*4矩阵
export function composeMatrix (position, quaternion, scale ) {
	var te = [];
	var x = quaternion[0], y = quaternion[1], z = quaternion[2], w = quaternion[3];
	var x2 = x + x, y2 = y + y, z2 = z + z;
	var xx = x * x2, xy = x * y2, xz = x * z2;
	var yy = y * y2, yz = y * z2, zz = z * z2;
	var wx = w * x2, wy = w * y2, wz = w * z2;
	var sx = scale[0], sy = scale[1], sz = scale[2];
	te[ 0 ] = ( 1 - ( yy + zz ) ) * sx;
	te[ 1 ] = ( xy + wz ) * sx;
	te[ 2 ] = ( xz - wy ) * sx;
	te[ 3 ] = 0;
	te[ 4 ] = ( xy - wz ) * sy;
	te[ 5 ] = ( 1 - ( xx + zz ) ) * sy;
	te[ 6 ] = ( yz + wx ) * sy;
	te[ 7 ] = 0;
	te[ 8 ] = ( xz + wy ) * sz;
	te[ 9 ] = ( yz - wx ) * sz;
	te[ 10 ] = ( 1 - ( xx + yy ) ) * sz;
	te[ 11 ] = 0;
	te[ 12 ] = position[0];
	te[ 13 ] = position[1];
	te[ 14 ] = position[2];
	te[ 15 ] = 1;
	return te;
}
//获取逆矩阵
export function getInverseMatrix (me){
	var te = [];
	var n11 = me[ 0 ], n21 = me[ 1 ], n31 = me[ 2 ], n41 = me[ 3 ],
	n12 = me[ 4 ], n22 = me[ 5 ], n32 = me[ 6 ], n42 = me[ 7 ],
	n13 = me[ 8 ], n23 = me[ 9 ], n33 = me[ 10 ], n43 = me[ 11 ],
	n14 = me[ 12 ], n24 = me[ 13 ], n34 = me[ 14 ], n44 = me[ 15 ],
	t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44,
	t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44,
	t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44,
	t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
	var det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
	if ( det === 0 ) {
		return this.set( 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 );
	}
	var detInv = 1 / det;
	te[ 0 ] = t11 * detInv;
	te[ 1 ] = ( n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44 ) * detInv;
	te[ 2 ] = ( n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44 ) * detInv;
	te[ 3 ] = ( n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43 ) * detInv;
	te[ 4 ] = t12 * detInv;
	te[ 5 ] = ( n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44 ) * detInv;
	te[ 6 ] = ( n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44 ) * detInv;
	te[ 7 ] = ( n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43 ) * detInv;
	te[ 8 ] = t13 * detInv;
	te[ 9 ] = ( n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44 ) * detInv;
	te[ 10 ] = ( n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44 ) * detInv;
	te[ 11 ] = ( n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43 ) * detInv;
	te[ 12 ] = t14 * detInv;
	te[ 13 ] = ( n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34 ) * detInv;
	te[ 14 ] = ( n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34 ) * detInv;
	te[ 15 ] = ( n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33 ) * detInv;
	return te;
}
//向量与矩阵相乘
export function vector3ApplyMatrix4 (vec3, e ) {
	var result = [];
	var x = vec3[0], y = vec3[1], z = vec3[2];
	var w = 1 / ( e[ 3 ] * x + e[ 7 ] * y + e[ 11 ] * z + e[ 15 ] );
	result[0] = ( e[ 0 ] * x + e[ 4 ] * y + e[ 8 ] * z + e[ 12 ] ) * w;
	result[1] = ( e[ 1 ] * x + e[ 5 ] * y + e[ 9 ] * z + e[ 13 ] ) * w;
	result[2] = ( e[ 2 ] * x + e[ 6 ] * y + e[ 10 ] * z + e[ 14 ] ) * w;
	return result;
}
//获取相对位置
export function getLocalPosition (campusCoordinates,azimuth,coordinates){
	//计算四元数时用到的角度
	var angle = campusCoordinates[0]+90;
	angle -= azimuth;
	var campusWorldPosition = lonlat2World(campusCoordinates[0],campusCoordinates[1],campusCoordinates[2]); // 将园区点经纬度转化成世界坐标
	var quaternion = getWorldQuaternion(campusWorldPosition,angle);
	var matrix = composeMatrix(campusWorldPosition,quaternion,[1,1,1]);
	var inversedMatrix = getInverseMatrix(matrix);
	var worldPosition = lonlat2World(coordinates[0],coordinates[1],coordinates[2]);// 将待求点经纬度转化成世界坐标
	var selfPosition = vector3ApplyMatrix4(worldPosition,inversedMatrix); // 根据参照点将待求点世界坐标系下的位置转换成园区坐标系下的坐标
	return selfPosition;
}
// //使用样例
//  var campusCoordinates = [115.9238, 40.5127];//园区的经度,纬度,高度 如果没有高度可以传0也可以只是用经纬度数组
//  var azimuth = 65;//园区方位角 单位为度 即园区z轴方向与正北方向顺时针的夹角
//  var gpsCoordinates = [115.9237889951027,40.51291036498085];//待求点经度,纬度,高度 如果没有高度可以传0也可以只是用经纬度数组
//  var result = getLocalPosition(campusCoordinates,azimuth,gpsCoordinates);



// WEBPACK FOOTER //
// ./src/utils/common.js